export const APP_NAME = 'jouf-media-cp'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const PERSIST_STORE_secretKey = 'jouf-media-secret-key'
export const REACT_APP_reCAPTCHA_SITE_KEY = '6Lc6z7InAAAAAFjQ3Tyk_GaFxdcL1AzMOHtF7UE-'
export const REACT_APP_reCAPTCHA_SECRET_KEY = '6Lc6z7InAAAAANslarCFqGaTinDiK5n9xYZp46M3'
